/**
 * Naive-UTC ISO -> local short timestamp ("Aug 23, 2:14 PM"), for the
 * Examples/Recent card rows (What-If HomeState + Query Forecast
 * QuestionLibrary, the shared list grammar §5) and ResultState's
 * "Calculated <at>" provenance line.
 *
 * `inserted_at` arrives as a NAIVE ISO string that is UTC by contract:
 * Agentic-API's persister writes datetime.now(timezone.utc)
 * .replace(tzinfo=None) and serializes with .isoformat(), so no zone
 * suffix survives. A bare `new Date(iso)` would parse that as LOCAL
 * time and shift the display by the viewer's UTC offset — invisible
 * while the rows showed only a date, wrong the moment time-of-day
 * renders. Appending 'Z' parses it as the UTC instant it is; an
 * already-suffixed value passes through untouched.
 */

const hasZoneSuffix = /[zZ]$|[+-]\d{2}:?\d{2}$/;

export const formatUtcTimestamp = (isoDate: string): string => {
  const parsed = new Date(
    hasZoneSuffix.test(isoDate) ? isoDate : `${isoDate}Z`
  );
  if (Number.isNaN(parsed.getTime())) return '';
  // e.g. "Aug 23, 2:14 PM" in en-US; follows the browser locale.
  return parsed.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};
